import { useCallback, useMemo, useState } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    hidden: {
      display: "none",
    },
    clickableTypo: {
      position: "relative",
      whiteSpace: "break-spaces",
      lineBreak: "anywhere",
      overflow: "visible",
      "&:hover": {
        cursor: "pointer",
      },
    },
    editButton: {
      position: "absolute",
      overflow: "visible",
    },
    AITContainer: {
      textAlign: "center",
    },
    typoContainer: {
      flexDirection: "column",
      justifyContent: "center",
    },
    typoLabel: {
      "&:hover": {
        cursor: "pointer",
      },
    },
  }),
);

const useAppInteractiveTypography = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const [visibleEdit, setVisibleEdit] = useState(false);

  const handleOver = useCallback(() => {
    setVisibleEdit(true);
  }, [setVisibleEdit]);

  const handleOut = useCallback(() => {
    setVisibleEdit(false);
  }, [setVisibleEdit]);

  return {
    styles,
    classes,
    atomicStyles,
    visibleEdit,
    handleOver,
    handleOut,
  };
};

export { useAppInteractiveTypography as default };
